import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import BrochureCard from "./BrochureCard";

const Brochure = () => {
  const [brochures, setBrochures] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/brochure/getbrochure`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data?.length) {
          setBrochures(data.data);
        }
      })
      .catch((err) => console.error("Error fetching brochures:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-slate-50 min-h-screen pb-24 relative">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_0%,rgba(99,102,241,0.05),transparent)] pointer-events-none" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 relative z-10">

        {/* Header Block */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-flex items-center gap-1.5 bg-indigo-50 text-indigo-600 border border-indigo-100 rounded-full px-4 py-1.5 text-xs font-semibold uppercase tracking-widest mb-4">
            <Icon icon="solar:document-bold-duotone" className="w-3.5 h-3.5" />
            Medical Brochures
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-gray-900 tracking-tight mb-4">
            Patient Guide & <span className="text-gradient">Brochures</span>
          </h1>
          <p className="text-sm text-gray-500 leading-relaxed max-w-xl mx-auto">
            Explore our curated guides, instructions, and brochures designed to walk you through vision therapy protocols.
          </p>
        </div>

        {/* List Content */}
        {loading ? (
          <div className="flex flex-col items-center justify-center py-24 gap-3">
            <div className="w-10 h-10 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin" />
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">Loading brochures...</p>
          </div>
        ) : brochures.length === 0 ? (
          <div className="text-center py-20 bg-white border border-gray-100 rounded-3xl shadow-sm">
            <Icon icon="solar:document-broken" className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <p className="text-base text-gray-500 font-medium">No brochures published yet.</p>
          </div>
        ) : (
          <div className="space-y-8">
            {brochures
              .slice()
              .reverse()
              .map((b) => (
                <BrochureCard key={b._id} brochure={b} />
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Brochure;
